import React from 'react';

import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

import { StatePanel, StatePanelTone } from './state-panel';
import { PageContainer, PageWidth } from './styled-components';

type RouteStateSeverity = 'error' | 'info' | 'warning';

interface RouteStateProps {
  action?: React.ReactNode;
  heading: string;
  message: string;
  severity: RouteStateSeverity;
  width?: PageWidth;
}

// Full-page authenticated state screen (access-denied, missing-session,
// unavailable, sign-in failed). Severity maps 1:1 to the shared StatePanel tone
// and a default mark; the heading is the page h1 and takes focus on mount.
const SEVERITY_TONES: Record<RouteStateSeverity, StatePanelTone> = {
  error: 'error',
  warning: 'warning',
  info: 'info',
};

const SEVERITY_ICONS: Record<RouteStateSeverity, React.ReactNode> = {
  error: <ErrorOutlineRoundedIcon />,
  warning: <WarningAmberRoundedIcon />,
  info: <InfoOutlinedIcon />,
};

export const RouteState: React.FC<RouteStateProps> = ({
  action,
  heading,
  message,
  severity,
  width,
}) => (
  <PageContainer $width={width}>
    <StatePanel
      action={action}
      focusOnMount
      heading={heading}
      headingLevel={1}
      icon={SEVERITY_ICONS[severity]}
      message={message}
      tone={SEVERITY_TONES[severity]}
    />
  </PageContainer>
);
